export const stamp = {
  en: {
    title: "PDF Stamp",
    toolTitle: "Stamp a PDF",
    toolNote: "Upload a PDF, drag the stamp where you want it, and download the stamped copy. Nothing is saved — the file is stamped and returned, and no record of it is kept.",
    choosePdf: "PDF file (max 20 MB)",
    chooseStamp: "Stamp",
    defaultSuffix: "default",
    dragHint: "Drag the stamp to position it. It is applied to all {pages} page(s) at the same place.",
    applyAndDownload: "Stamp and download",
    noStamps: "No active stamps. Add one below.",

    errorNotPdf: "Only PDF files can be stamped.",
    errorTooLarge: "The PDF must be 20 MB or smaller.",
    errorUnreadable: "That PDF could not be opened. It may be encrypted or damaged.",
    errorFailed: "The PDF could not be stamped.",

    manageTitle: "Stamp management",
    manageNote: "The stamps this tool offers. Sizes are in PDF points — 72 points to the inch, so 120 × 80 is about 42 × 28 mm.",
    noTemplates: "No stamps yet.",
    colImage: "Image",
    colName: "Name",
    colSize: "Size",
    isDefault: "Default",
    active: "Active",
    inactive: "Inactive",
    activate: "Activate",
    deactivate: "Deactivate",
    makeDefault: "Make default",
    addTitle: "Add a stamp",
    addAction: "Add stamp",
    nameArLabel: "Name (Arabic)",
    widthLabel: "Width (points)",
    heightLabel: "Height (points)",
    imageLabel: "Image (PNG or JPEG)",
    replaceImageLabel: "Replace image (PNG or JPEG)",
    editTitle: "Edit stamp",
    deleteTitle: "Delete this stamp?",
    deleteBody: "{name} will be removed from the library. Documents already stamped with it are unaffected.",
  },
  ar: {
    title: "ختم المستندات",
    toolTitle: "ختم ملف PDF",
    toolNote: "ارفع ملف PDF، واسحب الختم إلى الموضع المطلوب، ثم نزّل النسخة المختومة. لا يُحفظ شيء — يُختم الملف ويُعاد دون الاحتفاظ بأي سجل عنه.",
    choosePdf: "ملف PDF (بحد أقصى 20 ميجابايت)",
    chooseStamp: "الختم",
    defaultSuffix: "الافتراضي",
    dragHint: "اسحب الختم لتحديد موضعه. سيُطبَّق على جميع الصفحات ({pages}) في الموضع نفسه.",
    applyAndDownload: "ختم وتنزيل",
    noStamps: "لا توجد أختام مفعّلة. أضف ختماً أدناه.",

    errorNotPdf: "لا يمكن ختم سوى ملفات PDF.",
    errorTooLarge: "يجب ألا يتجاوز حجم ملف PDF 20 ميجابايت.",
    errorUnreadable: "تعذّر فتح ملف PDF. قد يكون محمياً أو تالفاً.",
    errorFailed: "تعذّر ختم الملف.",

    manageTitle: "إدارة الأختام",
    manageNote: "الأختام المتاحة في هذه الأداة. المقاسات بوحدة نقاط PDF — 72 نقطة لكل بوصة، أي أن 120 × 80 تعادل نحو 42 × 28 مم.",
    noTemplates: "لا توجد أختام بعد.",
    colImage: "الصورة",
    colName: "الاسم",
    colSize: "المقاس",
    isDefault: "افتراضي",
    active: "مفعّل",
    inactive: "غير مفعّل",
    activate: "تفعيل",
    deactivate: "إلغاء التفعيل",
    makeDefault: "تعيين كافتراضي",
    addTitle: "إضافة ختم",
    addAction: "إضافة الختم",
    nameArLabel: "الاسم (بالعربية)",
    widthLabel: "العرض (نقاط)",
    heightLabel: "الارتفاع (نقاط)",
    imageLabel: "الصورة (PNG أو JPEG)",
    replaceImageLabel: "استبدال الصورة (PNG أو JPEG)",
    editTitle: "تعديل الختم",
    deleteTitle: "حذف هذا الختم؟",
    deleteBody: "سيُحذف {name} من المكتبة. المستندات المختومة به مسبقاً لن تتأثر.",
  },
} as const;
